export const Objects = function(obj) {
  if (obj != undefined && JSON.stringify(obj) !== '{}' && obj !== '' && obj != null) {
		return true
	} else {
		return false
	}
}